// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { RecurrenceMode } from "./recurrence-mode";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A scheduled Control command bound to a bank.
 */
export class TimedAction implements flatbuffers.IUnpackableObject<TimedActionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TimedAction {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTimedAction(bb: flatbuffers.ByteBuffer, obj?: TimedAction): TimedAction {
    return (obj || new TimedAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTimedAction(
    bb: flatbuffers.ByteBuffer,
    obj?: TimedAction,
  ): TimedAction {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TimedAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * A timed action is bank-bound and banks are org-bound, so this is always
   * present. Required for parity with every other bank-scoped archive table
   * (`ActionBank`, Adapter, Lift, `BankFloor`).
   */
  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Optional per-car target; NULL = bank-wide. Mirrors `ActionCatalog`.lift_id.
   * Runtime dispatch sets UiCmd.lift_id from this when present.
   */
  liftId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  /**
   * When false the scheduler ignores this row entirely.
   */
  enabled(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * `Control::Control` enum value fired at the START time (e.g. CarCallLock=0,
   * UpHallCallLock=4, EnergizeCarCall=12). Stored as a scalar — never a
   * ControlVariant union (v4 round-trip lesson). Content discriminant is
   * implicitly Control. Widened to int to match `ActionCatalog.message_value`.
   */
  startMessageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Complementary `Control::Control` enum value fired at the STOP time
   * (e.g. CarCallUnlock=1, UpHallCallUnlock=5). Stored as a scalar.
   */
  stopMessageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Target floor/position for energize-style elevator commands. 0 = unused.
   * Mirrors `ActionCatalog.target_position` and ElevatorControlMessage.position.
   */
  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Monitoring-state gate (parity with `ActionCatalog`/`ActionBank`.valid_states):
   * the scheduler only fires when the lift's current state is in this set.
   * Empty = fire unconditionally. `PostgreSQL` text[] / `FlatBuffer` string vector.
   */
  validStates(index: number): string;
  validStates(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  validStates(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  validStatesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Scheduling mode. ONE_SHOT (0, the default) uses start_at/stop_at; DAILY (1)
   * and WEEKLY (2) use the seconds-of-day + days_of_week + timezone fields below
   * (WEEKLY adds week_interval); MONTHLY (3) uses days_of_month + seconds-of-day +
   * timezone; INTERVAL (4) uses interval_seconds within [start_at, stop_at].
   */
  recurrenceMode(): RecurrenceMode {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : RecurrenceMode.ONE_SHOT;
  }

  /**
   * DAILY mode — local-time seconds since midnight (0..86399) at which the
   * start / stop command fires. Ignored in ONE_SHOT mode.
   */
  startSecondsOfDay(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  stopSecondsOfDay(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * DAILY mode — 7-bit weekday mask. bit0=Sunday, bit1=Monday … bit6=Saturday.
   * 0 is treated by the scheduler as "every day". Ignored in ONE_SHOT mode.
   */
  daysOfWeek(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  /**
   * DAILY mode — IANA timezone (e.g. "`America/New_York`") the seconds-of-day are
   * interpreted in. Empty string = UTC. Ignored in ONE_SHOT mode.
   */
  timezone(): string | null;
  timezone(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  timezone(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * DAILY mode — when true the stop fires on the day AFTER the start day,
   * encoding an overnight window (e.g. lock 22:00 → unlock 06:00 next day).
   * Default false = same-day window. Resolves the stop<start ambiguity
   * explicitly across all language implementations. Ignored in ONE_SHOT mode.
   */
  stopNextDay(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * ONE_SHOT mode — ISO-8601 datetimes the start / stop command fires at.
   * Ignored in DAILY mode.
   */
  startAt(): string | null;
  startAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  startAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  stopAt(): string | null;
  stopAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  stopAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Fire-once / idempotency state. ISO-8601 timestamp of the last time the
   * start (resp. stop) command actually fired; empty = never fired. Persisted
   * so a re-imported .lnx or a restarted edge node does NOT re-fire a past
   * ONE_SHOT. For DAILY these track the most recent fire for observability.
   */
  lastStartedAt(): string | null;
  lastStartedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  lastStartedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  lastStoppedAt(): string | null;
  lastStoppedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  lastStoppedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * WEEKLY mode — fire only every Nth week. 0 or 1 = every week (identical to
   * DAILY with the same day mask). The anchor week is derived from `start_at`;
   * when `week_interval` > 1, `start_at` MUST be set. Ignored in other modes.
   * Appended additively (append-only schema rule). Default 0 so pre-existing
   * rows decode as "every week".
   */
  weekInterval(): number {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * MONTHLY mode — day-of-month bitmask. bit i (0..30) => day (i+1); bit 31 =>
   * the last calendar day of the month (28/29/30/31). 0 = no day selected, so
   * the scheduler never fires. Stored as a bitmask, NOT an ordinal: when bit 31
   * is set the value is negative as a signed int32 over JSON. Ignored in other
   * modes.
   */
  daysOfMonth(): number {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * INTERVAL mode — pulse period in seconds for the START command within the
   * absolute [start_at, stop_at] window, anchored at start_at. 0 = disabled.
   * Must be >= the scheduler tick (30s); finer intervals coalesce to one pulse
   * per tick. STOP fires once at stop_at. Ignored in other modes.
   */
  intervalSeconds(): number {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Full set of banks this action targets. EMPTY (the default, and the value
   * every pre-existing row decodes to) means the target bank set is exactly
   * `{bank_id}` — so old rows keep their old meaning.
   *
   * INVARIANT, asserted on write and on read: when this vector is non-empty,
   * `bank_ids[0]` MUST equal `bank_id`. `bank_id` stays the required FK
   * anchor (org scoping, cascade delete, and the channel lookup all key off
   * it), so the two must never disagree about which bank owns the row.
   */
  bankIds(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bankIdsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Full set of lifts (cars) this action targets. EMPTY means fall back to
   * the scalar `lift_id`; when that is NULL too, the action is bank-wide and
   * resolves to every lift in each targeted bank. A non-empty vector is the
   * authoritative set and `lift_id` is ignored.
   *
   * Lifts are NOT required to belong to the banks in `bank_ids`: the
   * dispatcher only emits a (bank, lift) pair when the lift actually belongs
   * to that bank, so a mixed selection degrades to the valid subset rather
   * than dispatching a command at a car that is not there.
   */
  liftIds(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  liftIdsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Floor set in mathematical interval notation. EMPTY means fall back to the
   * scalar `position` (preserving the single-floor behaviour of every
   * pre-existing row).
   *
   * Grammar (ASCII only; whitespace between tokens is insignificant):
   *     spec     := member (',' member)*      -- comma at bracket depth 0
   *     member   := interval | integer        -- bare integer = singleton
   *     interval := `('['|'(')` integer ',' integer `(']'|')')`
   *     integer  := '-'? DIGIT+
   * `[` / `]` include the bound, `(` / `)` exclude it, so `[1,5)` is
   * {1,2,3,4} and `(1,5]` is {2,3,4,5}. Members may be unioned:
   * `[1,5),[10,12]` is {1,2,3,4,10,11,12}.
   *
   * Validation is STRICT and identical in every language implementation —
   * a spec is rejected (never coerced, never silently emptied) when it is
   * malformed, when a lower bound exceeds its upper bound, when a member
   * resolves to the EMPTY set (`[3,3)`, `(3,3]`, `(3,4)`), when its
   * expansion would exceed the per-spec floor cap, or when a resolved floor
   * is not a floor of any targeted bank. Cardinality is computed from the
   * bounds arithmetically, BEFORE expansion, so a pathological interval
   * such as `[-2147483648,2147483647)` is rejected rather than materialised.
   */
  floorSpec(): string | null;
  floorSpec(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  floorSpec(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Active state carried on `UiCmd.active` when the START command fires.
   * `start_message_value` need not differ from `stop_message_value`: the
   * same Control enum with opposite active states is a legal, common
   * configuration (e.g. CarCallLock active:true to start, CarCallLock
   * active:false to stop) — see validateTimedAction's guard that the
   * resolved (value, active) pair must actually differ between the two.
   */
  startMessageActive(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * Active state carried on `UiCmd.active` when the STOP command fires.
   */
  stopMessageActive(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 64);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * The Nth occurrence of the configured weekday in the month (1..5).
   * Ignored when `month_week_last` is true. Default 1, NOT 0: an ordinal
   * of 0 matches no occurrence arithmetically ((day-1)/7+1 is always >= 1),
   * so a row that decoded a missing value as 0 would silently never fire —
   * the same zero-sentinel trap `enabled`'s own history in this schema
   * documents. A month with no 5th occurrence of the configured weekday
   * simply does not fire that month (standard recurrence-rule behaviour).
   */
  monthWeekOrdinal(): number {
    const offset = this.bb!.__offset(this.bb_pos, 66);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 1;
  }

  /**
   * True selects the LAST occurrence of the configured weekday in the
   * month instead of the Nth — overrides `month_week_ordinal`. Default
   * false, so a pre-existing row (none exist yet; this mode is new)
   * would decode as ordinal-based, matching the field's own default.
   */
  monthWeekLast(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 68);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startTimedAction(builder: flatbuffers.Builder) {
    builder.startObject(33);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bankIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, liftIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, nameOffset, 0);
  }

  static addEnabled(builder: flatbuffers.Builder, enabled: boolean) {
    builder.addFieldInt8(5, +enabled, +true);
  }

  static addStartMessageValue(builder: flatbuffers.Builder, startMessageValue: number) {
    builder.addFieldInt32(6, startMessageValue, 0);
  }

  static addStopMessageValue(builder: flatbuffers.Builder, stopMessageValue: number) {
    builder.addFieldInt32(7, stopMessageValue, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt32(8, position, 0);
  }

  static addValidStates(builder: flatbuffers.Builder, validStatesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, validStatesOffset, 0);
  }

  static createValidStatesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startValidStatesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addRecurrenceMode(builder: flatbuffers.Builder, recurrenceMode: RecurrenceMode) {
    builder.addFieldInt8(10, recurrenceMode, RecurrenceMode.ONE_SHOT);
  }

  static addStartSecondsOfDay(builder: flatbuffers.Builder, startSecondsOfDay: number) {
    builder.addFieldInt32(11, startSecondsOfDay, 0);
  }

  static addStopSecondsOfDay(builder: flatbuffers.Builder, stopSecondsOfDay: number) {
    builder.addFieldInt32(12, stopSecondsOfDay, 0);
  }

  static addDaysOfWeek(builder: flatbuffers.Builder, daysOfWeek: number) {
    builder.addFieldInt8(13, daysOfWeek, 0);
  }

  static addTimezone(builder: flatbuffers.Builder, timezoneOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, timezoneOffset, 0);
  }

  static addStopNextDay(builder: flatbuffers.Builder, stopNextDay: boolean) {
    builder.addFieldInt8(15, +stopNextDay, +false);
  }

  static addStartAt(builder: flatbuffers.Builder, startAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, startAtOffset, 0);
  }

  static addStopAt(builder: flatbuffers.Builder, stopAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, stopAtOffset, 0);
  }

  static addLastStartedAt(builder: flatbuffers.Builder, lastStartedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, lastStartedAtOffset, 0);
  }

  static addLastStoppedAt(builder: flatbuffers.Builder, lastStoppedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, lastStoppedAtOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(20, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(21, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(22, deletedAtOffset, 0);
  }

  static addWeekInterval(builder: flatbuffers.Builder, weekInterval: number) {
    builder.addFieldInt32(23, weekInterval, 0);
  }

  static addDaysOfMonth(builder: flatbuffers.Builder, daysOfMonth: number) {
    builder.addFieldInt32(24, daysOfMonth, 0);
  }

  static addIntervalSeconds(builder: flatbuffers.Builder, intervalSeconds: number) {
    builder.addFieldInt32(25, intervalSeconds, 0);
  }

  static addBankIds(builder: flatbuffers.Builder, bankIdsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(26, bankIdsOffset, 0);
  }

  static createBankIdsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBankIdsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addLiftIds(builder: flatbuffers.Builder, liftIdsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(27, liftIdsOffset, 0);
  }

  static createLiftIdsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLiftIdsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addFloorSpec(builder: flatbuffers.Builder, floorSpecOffset: flatbuffers.Offset) {
    builder.addFieldOffset(28, floorSpecOffset, 0);
  }

  static addStartMessageActive(builder: flatbuffers.Builder, startMessageActive: boolean) {
    builder.addFieldInt8(29, +startMessageActive, +true);
  }

  static addStopMessageActive(builder: flatbuffers.Builder, stopMessageActive: boolean) {
    builder.addFieldInt8(30, +stopMessageActive, +true);
  }

  static addMonthWeekOrdinal(builder: flatbuffers.Builder, monthWeekOrdinal: number) {
    builder.addFieldInt8(31, monthWeekOrdinal, 1);
  }

  static addMonthWeekLast(builder: flatbuffers.Builder, monthWeekLast: boolean) {
    builder.addFieldInt8(32, +monthWeekLast, +false);
  }

  static endTimedAction(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // bank_id
    builder.requiredField(offset, 8); // organization_id
    builder.requiredField(offset, 12); // name
    return offset;
  }

  unpack(): TimedActionT {
    return new TimedActionT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.liftId() !== null ? this.liftId()!.unpack() : null,
      this.name(),
      this.enabled(),
      this.startMessageValue(),
      this.stopMessageValue(),
      this.position(),
      this.bb!.createScalarList<string>(this.validStates.bind(this), this.validStatesLength()),
      this.recurrenceMode(),
      this.startSecondsOfDay(),
      this.stopSecondsOfDay(),
      this.daysOfWeek(),
      this.timezone(),
      this.stopNextDay(),
      this.startAt(),
      this.stopAt(),
      this.lastStartedAt(),
      this.lastStoppedAt(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.weekInterval(),
      this.daysOfMonth(),
      this.intervalSeconds(),
      this.bb!.createObjList<Uuid, UuidT>(this.bankIds.bind(this), this.bankIdsLength()),
      this.bb!.createObjList<Uuid, UuidT>(this.liftIds.bind(this), this.liftIdsLength()),
      this.floorSpec(),
      this.startMessageActive(),
      this.stopMessageActive(),
      this.monthWeekOrdinal(),
      this.monthWeekLast(),
    );
  }

  unpackTo(_o: TimedActionT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    _o.name = this.name();
    _o.enabled = this.enabled();
    _o.startMessageValue = this.startMessageValue();
    _o.stopMessageValue = this.stopMessageValue();
    _o.position = this.position();
    _o.validStates = this.bb!.createScalarList<string>(
      this.validStates.bind(this),
      this.validStatesLength(),
    );
    _o.recurrenceMode = this.recurrenceMode();
    _o.startSecondsOfDay = this.startSecondsOfDay();
    _o.stopSecondsOfDay = this.stopSecondsOfDay();
    _o.daysOfWeek = this.daysOfWeek();
    _o.timezone = this.timezone();
    _o.stopNextDay = this.stopNextDay();
    _o.startAt = this.startAt();
    _o.stopAt = this.stopAt();
    _o.lastStartedAt = this.lastStartedAt();
    _o.lastStoppedAt = this.lastStoppedAt();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.weekInterval = this.weekInterval();
    _o.daysOfMonth = this.daysOfMonth();
    _o.intervalSeconds = this.intervalSeconds();
    _o.bankIds = this.bb!.createObjList<Uuid, UuidT>(this.bankIds.bind(this), this.bankIdsLength());
    _o.liftIds = this.bb!.createObjList<Uuid, UuidT>(this.liftIds.bind(this), this.liftIdsLength());
    _o.floorSpec = this.floorSpec();
    _o.startMessageActive = this.startMessageActive();
    _o.stopMessageActive = this.stopMessageActive();
    _o.monthWeekOrdinal = this.monthWeekOrdinal();
    _o.monthWeekLast = this.monthWeekLast();
  }

  unpackFields(...fields: string[]): TimedActionT {
    const t = new TimedActionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("enabled")) {
      t.enabled = this.enabled();
    }
    if (fieldSet.has("start_message_value")) {
      t.startMessageValue = this.startMessageValue();
    }
    if (fieldSet.has("stop_message_value")) {
      t.stopMessageValue = this.stopMessageValue();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("valid_states")) {
      t.validStates = this.bb!.createScalarList<string>(
        this.validStates.bind(this),
        this.validStatesLength(),
      );
    }
    if (fieldSet.has("recurrence_mode")) {
      t.recurrenceMode = this.recurrenceMode();
    }
    if (fieldSet.has("start_seconds_of_day")) {
      t.startSecondsOfDay = this.startSecondsOfDay();
    }
    if (fieldSet.has("stop_seconds_of_day")) {
      t.stopSecondsOfDay = this.stopSecondsOfDay();
    }
    if (fieldSet.has("days_of_week")) {
      t.daysOfWeek = this.daysOfWeek();
    }
    if (fieldSet.has("timezone")) {
      t.timezone = this.timezone();
    }
    if (fieldSet.has("stop_next_day")) {
      t.stopNextDay = this.stopNextDay();
    }
    if (fieldSet.has("start_at")) {
      t.startAt = this.startAt();
    }
    if (fieldSet.has("stop_at")) {
      t.stopAt = this.stopAt();
    }
    if (fieldSet.has("last_started_at")) {
      t.lastStartedAt = this.lastStartedAt();
    }
    if (fieldSet.has("last_stopped_at")) {
      t.lastStoppedAt = this.lastStoppedAt();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("week_interval")) {
      t.weekInterval = this.weekInterval();
    }
    if (fieldSet.has("days_of_month")) {
      t.daysOfMonth = this.daysOfMonth();
    }
    if (fieldSet.has("interval_seconds")) {
      t.intervalSeconds = this.intervalSeconds();
    }
    if (fieldSet.has("bank_ids")) {
      t.bankIds = this.bb!.createObjList<Uuid, UuidT>(
        this.bankIds.bind(this),
        this.bankIdsLength(),
      );
    }
    if (fieldSet.has("lift_ids")) {
      t.liftIds = this.bb!.createObjList<Uuid, UuidT>(
        this.liftIds.bind(this),
        this.liftIdsLength(),
      );
    }
    if (fieldSet.has("floor_spec")) {
      t.floorSpec = this.floorSpec();
    }
    if (fieldSet.has("start_message_active")) {
      t.startMessageActive = this.startMessageActive();
    }
    if (fieldSet.has("stop_message_active")) {
      t.stopMessageActive = this.stopMessageActive();
    }
    if (fieldSet.has("month_week_ordinal")) {
      t.monthWeekOrdinal = this.monthWeekOrdinal();
    }
    if (fieldSet.has("month_week_last")) {
      t.monthWeekLast = this.monthWeekLast();
    }
    return t;
  }
}

export class TimedActionT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public bankId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public liftId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public enabled: boolean = true,
    public startMessageValue: number = 0,
    public stopMessageValue: number = 0,
    public position: number = 0,
    public validStates: string[] = [],
    public recurrenceMode: RecurrenceMode = RecurrenceMode.ONE_SHOT,
    public startSecondsOfDay: number = 0,
    public stopSecondsOfDay: number = 0,
    public daysOfWeek: number = 0,
    public timezone: string | Uint8Array | null = null,
    public stopNextDay: boolean = false,
    public startAt: string | Uint8Array | null = null,
    public stopAt: string | Uint8Array | null = null,
    public lastStartedAt: string | Uint8Array | null = null,
    public lastStoppedAt: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public weekInterval: number = 0,
    public daysOfMonth: number = 0,
    public intervalSeconds: number = 0,
    public bankIds: UuidT[] = [],
    public liftIds: UuidT[] = [],
    public floorSpec: string | Uint8Array | null = null,
    public startMessageActive: boolean = true,
    public stopMessageActive: boolean = true,
    public monthWeekOrdinal: number = 1,
    public monthWeekLast: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const liftId = this.liftId !== null ? this.liftId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const validStates = TimedAction.createValidStatesVector(
      builder,
      builder.createObjectOffsetList(this.validStates),
    );
    const timezone = this.timezone !== null ? builder.createString(this.timezone!) : 0;
    const startAt = this.startAt !== null ? builder.createString(this.startAt!) : 0;
    const stopAt = this.stopAt !== null ? builder.createString(this.stopAt!) : 0;
    const lastStartedAt =
      this.lastStartedAt !== null ? builder.createString(this.lastStartedAt!) : 0;
    const lastStoppedAt =
      this.lastStoppedAt !== null ? builder.createString(this.lastStoppedAt!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const bankIds = TimedAction.createBankIdsVector(
      builder,
      builder.createObjectOffsetList(this.bankIds),
    );
    const liftIds = TimedAction.createLiftIdsVector(
      builder,
      builder.createObjectOffsetList(this.liftIds),
    );
    const floorSpec = this.floorSpec !== null ? builder.createString(this.floorSpec!) : 0;

    TimedAction.startTimedAction(builder);
    TimedAction.addId(builder, id);
    TimedAction.addBankId(builder, bankId);
    TimedAction.addOrganizationId(builder, organizationId);
    TimedAction.addLiftId(builder, liftId);
    TimedAction.addName(builder, name);
    TimedAction.addEnabled(builder, this.enabled);
    TimedAction.addStartMessageValue(builder, this.startMessageValue);
    TimedAction.addStopMessageValue(builder, this.stopMessageValue);
    TimedAction.addPosition(builder, this.position);
    TimedAction.addValidStates(builder, validStates);
    TimedAction.addRecurrenceMode(builder, this.recurrenceMode);
    TimedAction.addStartSecondsOfDay(builder, this.startSecondsOfDay);
    TimedAction.addStopSecondsOfDay(builder, this.stopSecondsOfDay);
    TimedAction.addDaysOfWeek(builder, this.daysOfWeek);
    TimedAction.addTimezone(builder, timezone);
    TimedAction.addStopNextDay(builder, this.stopNextDay);
    TimedAction.addStartAt(builder, startAt);
    TimedAction.addStopAt(builder, stopAt);
    TimedAction.addLastStartedAt(builder, lastStartedAt);
    TimedAction.addLastStoppedAt(builder, lastStoppedAt);
    TimedAction.addCreatedAt(builder, createdAt);
    TimedAction.addUpdatedAt(builder, updatedAt);
    TimedAction.addDeletedAt(builder, deletedAt);
    TimedAction.addWeekInterval(builder, this.weekInterval);
    TimedAction.addDaysOfMonth(builder, this.daysOfMonth);
    TimedAction.addIntervalSeconds(builder, this.intervalSeconds);
    TimedAction.addBankIds(builder, bankIds);
    TimedAction.addLiftIds(builder, liftIds);
    TimedAction.addFloorSpec(builder, floorSpec);
    TimedAction.addStartMessageActive(builder, this.startMessageActive);
    TimedAction.addStopMessageActive(builder, this.stopMessageActive);
    TimedAction.addMonthWeekOrdinal(builder, this.monthWeekOrdinal);
    TimedAction.addMonthWeekLast(builder, this.monthWeekLast);

    return TimedAction.endTimedAction(builder);
  }

  clone(): TimedActionT {
    const obj = new TimedActionT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.liftId = this.liftId !== null ? this.liftId!.clone() : null;
    obj.name = this.name;
    obj.enabled = this.enabled;
    obj.startMessageValue = this.startMessageValue;
    obj.stopMessageValue = this.stopMessageValue;
    obj.position = this.position;
    obj.validStates = [...this.validStates];
    obj.recurrenceMode = this.recurrenceMode;
    obj.startSecondsOfDay = this.startSecondsOfDay;
    obj.stopSecondsOfDay = this.stopSecondsOfDay;
    obj.daysOfWeek = this.daysOfWeek;
    obj.timezone = this.timezone;
    obj.stopNextDay = this.stopNextDay;
    obj.startAt = this.startAt;
    obj.stopAt = this.stopAt;
    obj.lastStartedAt = this.lastStartedAt;
    obj.lastStoppedAt = this.lastStoppedAt;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.weekInterval = this.weekInterval;
    obj.daysOfMonth = this.daysOfMonth;
    obj.intervalSeconds = this.intervalSeconds;
    obj.bankIds = this.bankIds.map((e) => e.clone());
    obj.liftIds = this.liftIds.map((e) => e.clone());
    obj.floorSpec = this.floorSpec;
    obj.startMessageActive = this.startMessageActive;
    obj.stopMessageActive = this.stopMessageActive;
    obj.monthWeekOrdinal = this.monthWeekOrdinal;
    obj.monthWeekLast = this.monthWeekLast;
    return obj;
  }

  equals(other: TimedActionT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.liftId !== null && other.liftId !== null) {
      if (!this.liftId!.equals(other.liftId!)) return false;
    } else if (this.liftId !== other.liftId) return false;
    if (this.name !== other.name) return false;
    if (this.enabled !== other.enabled) return false;
    if (this.startMessageValue !== other.startMessageValue) return false;
    if (this.stopMessageValue !== other.stopMessageValue) return false;
    if (this.position !== other.position) return false;
    if (this.validStates.length !== other.validStates.length) return false;
    for (let i = 0; i < this.validStates.length; i++) {
      if (this.validStates[i] !== other.validStates[i]) return false;
    }
    if (this.recurrenceMode !== other.recurrenceMode) return false;
    if (this.startSecondsOfDay !== other.startSecondsOfDay) return false;
    if (this.stopSecondsOfDay !== other.stopSecondsOfDay) return false;
    if (this.daysOfWeek !== other.daysOfWeek) return false;
    if (this.timezone !== other.timezone) return false;
    if (this.stopNextDay !== other.stopNextDay) return false;
    if (this.startAt !== other.startAt) return false;
    if (this.stopAt !== other.stopAt) return false;
    if (this.lastStartedAt !== other.lastStartedAt) return false;
    if (this.lastStoppedAt !== other.lastStoppedAt) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.weekInterval !== other.weekInterval) return false;
    if (this.daysOfMonth !== other.daysOfMonth) return false;
    if (this.intervalSeconds !== other.intervalSeconds) return false;
    if (this.bankIds.length !== other.bankIds.length) return false;
    for (let i = 0; i < this.bankIds.length; i++) {
      const a = this.bankIds[i];
      const b = other.bankIds[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.liftIds.length !== other.liftIds.length) return false;
    for (let i = 0; i < this.liftIds.length; i++) {
      const a = this.liftIds[i];
      const b = other.liftIds[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.floorSpec !== other.floorSpec) return false;
    if (this.startMessageActive !== other.startMessageActive) return false;
    if (this.stopMessageActive !== other.stopMessageActive) return false;
    if (this.monthWeekOrdinal !== other.monthWeekOrdinal) return false;
    if (this.monthWeekLast !== other.monthWeekLast) return false;
    return true;
  }
}

export function verifyTimedAction(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "bank_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "organization_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "name");
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    verifier.checkScalarField(tablePos, 24, 1);
    verifier.checkScalarField(tablePos, 26, 4);
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 34, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 46);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 50, 4);
    verifier.checkScalarField(tablePos, 52, 4);
    verifier.checkScalarField(tablePos, 54, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 56);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 58);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 60);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 62, 1);
    verifier.checkScalarField(tablePos, 64, 1);
    verifier.checkScalarField(tablePos, 66, 1);
    verifier.checkScalarField(tablePos, 68, 1);
  } finally {
    verifier.popDepth();
  }
}
